<template>
  <Loading
    :contentSize="true"
    :state="loading"
  >
    <div class="wrapper">
      <table
        border="0"
        cellspacing="0"
        cellpadding="0"
        class="attrs main"
        v-if="fields"
      >
        <caption></caption>
        <tr>
          <th scope="row">{{ $t( "Classes" ) }}</th>
          <td>
            <div
              class="field"
              v-for="( cls, n ) of fields[ $options.aType ].values"
              :key="cls.id"
            >
              <DVfield
                class="DVfield"

                type="reference"
                :refs="attrGetRefs( $options.aType )"
                :misc="{ URL: '/editing/ac', params: apiQueryStd }"

                :value="fieldGetValue( $options.aType, n )"

                :disabled="!canSave"

                @input="fieldSetValue( $options.aType, n, $event )"
                @ok=""
              />
              <router-link
                class="link"
                :title="$t( 'ObjectView' )"

                v-if="cls && cls.id"

                :to="viewLink( cls.id )"
              >
                <Icon
                  symbol="view"
                />
              </router-link>
              <button
                v-if="fieldCanAdd( $options.aType )"
                :title="$t( 'ValueAdd' )"
                @click="fieldAdd( $options.aType, n )"
              >
                <Icon
                  symbol="add"
                  size="0.8em"
                />
              </button>
              <button
                v-if="fieldCanRemove( $options.aType )"
                :title="$t( 'ValueRemove' )"
                @click="fieldRem( $options.aType, n )"
              >
                <Icon
                  symbol="remove"
                  size="0.8em"
                />
              </button>

              <Tooltip
                style="position: absolute"

                ref="fieldErrorTip"

                :show="!!fieldsErrorGet( $options.aType, n )"

                orientation="bottom"
                type="error"

                @close="fieldsErrorClear( $options.aType, n )"
              >
                <span v-html="fieldsErrorGet( $options.aType, n )"></span>
              </Tooltip>
            </div>
          </td>
          <td
            v-if="historyButtons"
          >
          </td>
        </tr>
        <tr
          v-if="aid != $options.aType"
          v-for="( attr, aid ) in attrs_"
          :key="aid"
        >
          <th scope="row">
            {{ attr.name }}
            <div
              v-if="item_ && item_.attrs && item_.attrs[ aid ] && item_.attrs[ aid ].violations"
              class="violations"
              :class="violationsSeverityGet( item_.attrs[ aid ].violations )"
            >
              <Icon
                symbol="alert"

                @mouseenter.native="$set( item_.attrs[ aid ], 'violationsShow', true ); $forceUpdate()"
                @mouseleave.native="$set( item_.attrs[ aid ], 'violationsShow', false ); $forceUpdate()"
              />

              <Tooltip
                orientation="bottom"
                :show="!!item_.attrs[ aid ].violationsShow"
                :closeIcon="false"
                :wrap="false"
                :iteraction="false"
                anglePosition="start"
                type="normal"
                class="tip"
              >
                <div v-for="vio of item_.attrs[ aid ].violations" class="violation">{{ vio.msg }}</div>
              </Tooltip>
            </div>

            <div
              v-if="consMandWarn( item_, aid )"
              class="consMand"
            >
              <Icon
                symbol="alert"

                @mouseenter.native="consMandAttrId = aid"
                @mouseleave.native="consMandAttrId = null"
              />

              <Tooltip
                orientation="bottom"
                :show="consMandAttrId == aid"
                :closeIcon="false"
                :wrap="false"
                :iteraction="false"
                anglePosition="start"
                type="normal"
                class="tip"
              >
                {{ $t( "ConsMandMsg" ) }}
              </Tooltip>
            </div>
          </th>
          <td>
            <template
              v-if="fields[ aid ].values.length "
            >
              <div
                v-for="( v, n ) of fields[ aid ].values"
                :key="aid + n"
                class="field"
              >
                <span v-if="v.lang" class="lang">{{ $t( "language" ) + " " + $langBrief( v.lang ) }}</span>
                <DVfield
                  class="DVfield"

                  :type="attr.type"
                  :refs="attrGetRefs( aid )"
                  :misc="{ URL: '/editing/ac', params: apiQueryStd }"

                  :value="fieldGetValue( aid, n, true )"

                  :disabled="!canSave"

                  @input="fieldSetValue( aid, n, $event )"
                  @ok=""

                  @error="fieldSetStatus( aid, n, $event )"
                />
                <router-link
                  class="link"

                  :title="$t( 'ObjectView' )"

                  v-if="referenceIs( attr ) && v && v.id"

                  :to="viewLink( v.id )"
                >
                  <Icon
                    symbol="view"
                  />
                </router-link>
                <button
                  @click="fieldAdd( aid, n )"
                  :title="$t( 'ValueAdd' )"
                  v-if="fieldCanAdd( aid )"
                >
                  <Icon
                    symbol="add"
                    size="0.8em"
                  />
                </button>
                <button
                  @click="fieldRem( aid, n )"
                  :title="$t( 'ValueRemove' )"
                  v-if="fieldCanRemove( aid )"
                >
                  <Icon
                    symbol="remove"
                    size="0.8em"
                  />
                </button>

                <Tooltip
                  style="position: absolute"

                  ref="fieldErrorTip"

                  :show="!!fieldsErrorGet( aid, n )"

                  orientation="bottom"
                  type="error"

                  @close="fieldsErrorClear( aid, n )"
                >
                  <span v-html="fieldsErrorGet( aid, n )"></span>
                </Tooltip>
              </div>
            </template>
            <div
              v-else
              class="field"
            >
              <button
                @click="fieldAdd( aid )"
                :title="$t( 'ValueAdd' )"
                v-if="fieldCanAdd( aid )"
              >
                <Icon
                  symbol="add"
                  size="0.8em"
                />
              </button>
            </div>

            <table
              border="0"
              cellspacing="0"
              cellpadding="0"

              v-if="item_.attrs[ aid ] && item_.attrs[ aid ].values && valuesContainInferred( item_.attrs[ aid ].values )"
            >
              <caption></caption>
              <tr
                class="inferred values"

                v-if="v.inferred"

                v-for="( v, i ) of item_.attrs[ aid ].values"
                :key="aid + i"
              ><td>
                <b>
                  <template v-if="referenceIs( attrs_[ aid ] )">
                    <router-link :to="viewLink( v.id )">{{ valueByAttr( v, aid ) }}</router-link>
                  </template>
                  <template v-else>
                    {{ valueByAttr( v, aid ) }}
                  </template>
                 </b> <span v-if="v.lang" class="lang">{{ $t( "language" ) + " " + $langBrief( v.lang ) }}</span> ({{ inferredRules[ v.inferred ] }})
              </td></tr>
            </table>

            <template
              v-if="item_.attrs[ aid ] && item_.attrs[ aid ].inferred"
            >
              <div
                class="inferred values"

                v-for="( v, n ) of item_.attrs[ aid ].values"
                :key="aid + '_' + n"
              >
                <b>
                  <template v-if="referenceIs( attrs_[ aid ] )">
                    <router-link :to="viewLink( v.id )">{{ valueByAttr( v, aid ) }}</router-link>
                  </template>
                  <template v-else>
                    {{ valueByAttr( v, aid ) }}
                  </template>
                 </b> <span v-if="v.lang" class="lang">{{ $t( "language" ) + " " + $langBrief( v.lang ) }}</span> ({{ inferredRules[ v.inferred ] }})
              </div>
            </template>
          </td>
          <td
              v-if="historyButtons"
          >
            <Icon
              class="historyAttrRq"
              symbol="history"
              :title="$t( 'AttributeHistoryRequest' )"

              @click.native="$emit( 'history', aid )"
            />
          </td>
        </tr>
      </table>
      <Button
        v-if="canSave"

        @click="save()"
        class="save"
      >
        {{ $t( "ChangesSave" ) }}
      </Button>
      <Button
        v-if="canDelete"

        class="del"
        :hollow="true"

        @click="deleteShow = true"
      >
        {{ $t( "Delete" ) }}
      </Button>
    </div>

    <Modal
      :show="deleteShow"
      :title="$t( 'Delete' ) + ' ' +  $t( 'object' ) + ' «' + itemName( item_ ) + '» ?<br /><br />'"
      :acceptButtonText="$t( 'Delete' )"
      :cancel-button-text="$t( 'cancel' )"
      :scrollContent="false"

      @accept="del()"
      @close="deleteShow = false"
      @cancel="deleteShow = false"
    >
    </Modal>
  </Loading>
</template>

<script>
  import utils from "@/utils";
  import dates from "@/dates";
  import fbu from "../frontbackUtils.js";

  import Loading from "@/components/Loading";
  import Icon from "@/components/Icon";
  import Modal from "@/components/Modal";
  import Tooltip from "@/components/Tooltip";
  import Button from "@/components/Button";
  import DVfield from "./DVfield";

  export default {
		name:  "ObjectEditor",

    components: {
      DVfield,
		  Loading,
      Icon,
      Modal,
      Tooltip,
      Button
    },

    utils,

    i18n: {
      messages: {
        ru: {
          AttributeHistoryRequest:        "Запросить историю изменений атрибута",
          AttributeHistoryView:           "Просмотр истории атрибута",
          ObjectClassesNotFound:          "Не найдены классы объекта",
          InvalidConstraintsRequestAnswer:"Ошибка формата ответа запроса логической целостности",
          ConstraintsDataError:           "Не возможно получить данные логической целостности",
          ObjectNoClassesOrProps:         "Объект не имеет схемы классов или свойств.",
          InvalidClassesSchemaAnswer:     "Ошибка формата ответа запроса схемы класса(в)",
          InvalidObjectRequestAnswer:     "Ошибка формата ответа запроса объекта",
          ValueRemove:                    "Убрать значение",
          ValueAdd:                       "Добавить еще значение",
          RefCantEmpty:                   "Указатель не может быть пустым",
          RefFillOrRemove:                "Заполните его, или удалите поле с ним",
          InvalidDateFormat:              "Неверный формат даты",
          UseDateFormat:                  "Используйте «дд.мм.гггг»",
          UseDatetimeFormat:              "Используйте «дд.мм.гггг чч:мм:сс»",
          InvalidFlagFormat:              "Неверный формат флага",
          UseFlagFormat:                  "Используйте «да» или «нет»",
          InvalidIntegerFormat:           "Неверный формат целого числа",
          UseIntegerFormat:               "Используйте цифры и символ \"-\", если необходимо",
          InvalidDoubleFormat:            "Неверный формат вещественного числа",
          UseDoubleFormat:                "Используйте цифры и символы \"-\" и \".\", если необходимо",
          ConsMandRequestErrors:          "Ошибка при запросе обязательных полей консолидации",
          ConsMandMsg:                    "Обязательно для консолидации, должно быть заполнено",
        },

        en: {
          AttributeHistoryRequest:        "Attribute history of changes request",
          AttributeHistoryView:           "Attribute history view",
          ObjectClassesNotFound:          "no object's classes",
          InvalidConstraintsRequestAnswer:"Invalid server's answer format for constraints rules request",
          ConstraintsDataError:           "Can't get constraints data",
          ObjectNoClassesOrProps:         "Object doesn't have classes or properties.",
          InvalidClassesSchemaAnswer:     "Invalid server's answer format for classes schema",
          InvalidObjectRequestAnswer:     "Invalid server's answer format for object",
          ValueRemove:                    "Remove value",
          ValueAdd:                       "Add value",
          RefCantEmpty:                   "Reference can't be empty",
          RefFillOrRemove:                "Fill it or remove field with it",
          InvalidDateFormat:              "Invalid date fromat",
          UseDateFormat:                  "Use «yyyy-dd-mm»",
          UseDatetimeFormat:              "Use «yyyy-dd-mm hh:mm:ss»",
          InvalidFlagFormat:              "Invalid flag format",
          UseFlagFormat:                  "Use «yes» or «no»",
          InvalidIntegerFormat:           "Invalid integer number format",
          UseIntegerFormat:               "Use digits and symbol \"-\" if necessary",
          InvalidDoubleFormat:            "Invalid float number format",
          UseDoubleFormat:                "Use digits and symbols \"-\" and \".\", if necessary",
          ConsMandRequestErrors:          "Mandatory consolidations fields request error",
          ConsMandMsg:                    "Mandatory for consolidation, must be filled",
        },

        kz: {
          AttributeHistoryRequest:        "Сұрау төлсипатының өзгеру тарихы",
          AttributeHistoryView:           "Төлсипат тарихын қарау",
          InvalidConstraintsRequestAnswer:"Логикалық тұтастық сұрауына жауап пішімінің қатесі",
          ConstraintsDataError:           "Логикалық тұтастық деректерін алу мүмкін емес",
          ObjectNoClassesOrProps:         "Нысанда сынып немесе сипат схемасы жоқ",
          InvalidClassesSchemaAnswer:     "Сыныптар диаграммасының сұрауына жауап пішімінің қатесі",
          InvalidObjectRequestAnswer:     "Нысан сұрауына жауап пішімі қатесі",
          ValueRemove:                    "Мәнді жою",
          ValueAdd:                       "Мән қосу",
          RefCantEmpty:                   "Көрсеткіш бос болуы мүмкін емес",
          RefFillOrRemove:                "Оны толтырыңыз немесе онымен өрісті жойыңыз",
          InvalidDateFormat:              "Күн пішімі жарамсыз",
          UseDateFormat:                  "«кк.аа.жжжж» пайдаланыңыз",
          UseDatetimeFormat:              "«кк.аа.жжжж сс:мм:сс» пайдаланыңыз",
          InvalidFlagFormat:              "Жарамсыз жалау пішімі",
          UseFlagFormat:                  "Иә немесе жоқ пайдаланыңыз",
          InvalidIntegerFormat:           "Жарамсыз бүтін сан пішімі",
          UseIntegerFormat:               "Қажет болса, сандар мен «-» таңбасын пайдаланыңыз",
          InvalidDoubleFormat:            "Қалқымалы сан пішімі жарамсыз",
          UseDoubleFormat:                "Қажет болса, «-» және «.» сандары мен таңбаларын пайдаланыңыз",
          ConsMandRequestErrors:          "Міндетті біріктіру өрістері қатені сұрайды",
          ConsMandMsg:                    "Біріктіру үшін міндетті, толтырылуы керек",
        }
      }
    },

    props: {
      id: {
		    type: String,
        mandatory: true
      },

      endpoint: {
        type: String,
        mandatory: true
      },

      classId: {
        type: String,
        mandatory: true
      },

      attrs: {
        type: Object,
        default() {
          return null;
        }
      },

      item: {
        type: Object,
        default() {
          return null;
        }
      },

      historyButtons: {
        type: Boolean,
        default: false
      },

      requestOnSave: {
        type: Boolean,
        default: true
      },

      canCreate: {
        type: Boolean,
        default: true
      },
      canUpdate: {
        type: Boolean,
        default: true
      },
      canDelete: {
        type: Boolean,
        default: true
      }
    },

    dates,
    hash: null,

    aType: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",

    data() {
		  return {
		    loading: true,

		    attrs_: null,
        item_: null,
        rulesInferred: {},
        /*
        set of all possible attributes for the entity (from attrs),
        filled by entity's not inferred attributes values and classes (from data),
        classes specified by owl:Class attribute

        the structure is:
        {
          attrId: {
            values: [
              {...},
              ...
            ]
          }
        }
        */
        consMandAttrId: null,
        fields: null,
        fieldsErrors: {},
        fieldsStatuses: {},

        deleteShow: false
      };
    },

    methods: {
		  viewLink( id ) {
        return `/editor/${encodeURIComponent( this.endpoint )}/${encodeURIComponent( this.classId )}/object/${encodeURIComponent( id )}`;
      },

      referenceIs( a ) {
		    return a && a.type === "reference";
      },

		  async dataRq( force ) {
		    this.loading = true;

		    const hash = utils.uniqueHashGen();
		    this.$options.hash = hash;

        try {
          let ans;

          let item = null, attrs = null;

          //get item data
   		    if ( !force && this.item ) ans = { item: this.item }
   		    else {
            ans = await this.$options.api.post.json(
              "/entities",
              {
                ...this.queryStd,

                id:       this.id,
                endpoint: this.endpoint,
                clientId: this.clientId
              }
            );
          }
          if ( ans ) {
            if ( ans.errors && ans.errors.length ) throw new Error( ans.errors.join( "<br />" ) );

            if ( ans.item && !utils.objIsEmpty( ans.item ) ) {
              item = ans.item;

              //get inferred rules if exists
              let inferredRules = {};
              let inferredRqs = [];
              for ( const aid in item.attrs ) {
                if ( item.attrs.hasOwnProperty( aid ) ) {
                  for ( const v of item.attrs[ aid ].values ) {
                    if ( v.inferred && !( v.inferred in inferredRules ) ) {
                      inferredRules[ v.inferred ] = v.inferred;
                      inferredRqs.push(
                        this.$options.api.post.json(
                          "/entities",
                          {
                            ...this.queryStd,

                            id:       v.inferred,
                            endpoint: this.endpoint,
                            clientId: this.clientId
                          }
                        )
                      );
                    }
                  }
                }
              }
              if ( inferredRqs.length ) {
                const anss = await Promise.allSettled( inferredRqs );
                for ( const ans of anss ) {
                  if ( ans && ans.value && ans.value.item ) {
                    const item = ans.value.item;
                    if ( item && item.name ) inferredRules[ item.id ] = item.name;
                  }
                }
              }
              this.inferredRules = inferredRules;

              //get attributes violations and class attributes
              ans = await this.$options.api.post.json(
                "/violations/attributes",
                {
                  ...this.queryStd,

                  id:       this.id,
                  endpoint: this.endpoint,
                  clientId: this.clientId,
                  lang:     this.langInterf
                }
              );

              const attrsVio = {};
              //violations
              if ( ans ) {
                if ( ans.items && ( this.id in ans.items ) ) {
                  for ( const vio of ans.items[ this.id ] ) {
                    for ( const aid of vio.attrs ) {
                      if ( !( aid in attrsVio ) ) attrsVio[ aid ] = [];

                      attrsVio[ aid ].push( vio );
                    }
                  }

                  if ( item ) {
                    for ( const aid in item.attrs ) {
                      if ( item.attrs.hasOwnProperty( aid ) ) {
                        const a = item.attrs[ aid ];

                        if ( aid in attrsVio ) {
                          a.violations = attrsVio[ aid ];
                          attrsVio[ aid ] = null;
                        }
                      }
                    }
                  }

                  for ( const aid in attrsVio ) {
                    if ( attrsVio.hasOwnProperty( aid ) ) {
                      if ( attrsVio[ aid ] !== null ) {
                        item.attrs[ aid ] = {
                          id:         aid,
                          values:     [ { value: "" } ],
                          violations: attrsVio[ aid ]
                        }
                      }
                    }
                  }
                }
              }
              else this.$root.$emit( "notify", { header: this.$t( "Error" ), message: this.$t( "InvalidConstraintsRequestAnswer" ), type: "error" } );
            }
            else throw new Error( this.$t( "Object" ) + " \"" + this.id + "\" " + this.$t( "notFound" ) );
          }
          else throw new Error( this.$t( "InvalidObjectRequestAnswer" ) + " \"" + this.id + "\"" );

          //classes ids of the item
          //if can not get classes from current item - request it
          let classes = Object.keys( item.classes );
          if ( !classes ) {
            ans = await this.$options.api.post.json(
              "/entity",
              {
                ...this.queryStd,

                id:       this.id,
                short:    true,
                endpoint: this.endpoint,
                clientId: this.clientId
              }
            );
            if ( ans && ans.item && !utils.objIsEmpty( ans.item ) ) classes = Object.keys( ans.item.classes );
            else console.error( "ENTITY \"" + this.id + "\" REQUEST ERROR: wrong server answer, " + JSON.encode( ans ) );
          }

          //consolidations mandatory fields
          if ( classes ) {
            ans = await this.$options.api.post.json(
              "/consolidation/attributes",
                {
                  ...this.queryStd,
                  id: classes,
                  endpoint: this.endpoint,
                  clientId: this.clientId,
                  lang:     this.langInterf
                }
            );
            if ( ans && ans.items ) {
              if ( ans.error ) throw new Error( this.$t( "ConsMandRequestError" ) + ": " + ans.error );
              if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( this.$t( "ConsMandRequestError" ) + ": " + ans.errors.join( "; " ) );

              this.consMand = new Set();
              for ( const i of ans.items ) {
                if ( i.mandatory ) this.consMand.add( i.id );
              }
            }
            else {
              console.error( "CONSOLIDATIONS MANDATORY ATTRIBUTES REQUEST ERROR: wrong server answer, " + JSON.encode( ans ) );
              throw new Error( this.$t( "ConsMandRequestError" ) );
            }
          }

          //get item schema
          if ( !force && this.attrs ) ans = { item: { attrs: this.attrs } };
          else {
            if ( !classes ) throw new Error( this.$t( "ObjectClassesNotFound" ) + " \"" + this.id + "\"" );

            ans = await this.$options.api.post.json(
              "/schemas",
              {
                ...this.queryStd,

                id:       classes,
                endpoint: this.endpoint,
                clientId: this.clientId,
                lang:     this.langInterf
              }
            );
          }
          if ( ans ) {
            if ( ans.errors && ans.errors.length ) throw new Error( ans.errors.join( "<br />" ) );

            if ( ans.item && !utils.objIsEmpty( ans.item ) ) {
              attrs = {};
              for ( const aid in ans.item.attrs ) {
                if ( ans.item.attrs.hasOwnProperty( aid ) ) {
                  const attr = ans.item.attrs[ aid ];
                  if ( attr.archive == true ) continue;

                  attrs[ attr.id ] = attr;
                }
              }
            }
            else {
              //вместо этого будет показано специальное сообщение
              //throw new Error( "схема класса(в) \"" + classes.join( ", " ) + "\" не найдена" );
              this.error = this.$t( "ObjectNoClassesOrProps" );
            }
          }
          else throw new Error( this.$t( "InvalidClassesSchemaAnswer" ) + "\"" + classes.join( ", " ) + "\"" );

          if ( this.$options.hash === hash ) {
            this.item_ = item;
            this.attrs_ = attrs;
          }
        }
        catch ( e ) {
          console.error( e );
          this.$root.$emit( "notify", { header: this.$t( "Error" ), message: e.message, type: "error" } );
        }

        this.loading = false;
      },

      valueByAttr( v, id ) {
		    if ( v ) {
		      if ( id && this.attrs_ && ( id in this.attrs_ ) ) {
  		      const type = this.attrs_[ id ].type ? this.attrs_[ id ].type.toLowerCase() : "";
  		      if ( type && type != "reference" ) return fbu.valueBackToFront( v, type, true, this.langInterf );
          }

		      if ( v && v.id ) return v.name ? v.name : v.id;
        }

		    return typeof( v ) == "string" ? v : "";
      },

      valuesContainInferred( v ) {
		    return v.find( i => i.inferred );
      },

      nameOrId( v, addId ) {
		    let n;

		    if ( v ) {
		      if ( v.name ) {
		        n = v.name;
		        if ( addId && v.id ) n += " (" + v.id + ")";
          }
		      else n = v.id;
        }
		    else n = "";

		    return n;
      },

      fieldCanAdd( id ) {
		    if ( this.canSave ) {
          if ( id in this.attrs_ ) {
            const attr = this.attrs_[ id ];
            const carMax = attr.carMax;
            //const carMin = attr.carMin;
            if ( carMax === null ) return true;
            const iAttr = id in this.fields ? this.fields[ id ] : null;
            if (
              carMax > 0 &&
              iAttr &&
              iAttr.values &&
              iAttr.values.length < carMax
            ) return true;
          }
        }

        return false;
      },

      fieldCanRemove( id  ) {
		    if ( this.canSave ) {
          if ( id in this.attrs_ ) {
            const attr = this.attrs_[ id ];
            //const carMax = attr.carMax;
            const carMin = attr.carMin;
            if ( carMin === null ) return true;
            const iAttr = id in this.fields ? this.fields[ id ] : null;
            if (
              carMin > 0 &&
              iAttr &&
              iAttr.values &&
              iAttr.values.length > carMin
            ) return true;
          }
        }

        return false;
      },

      fieldAdd( id, n ) {
		    if ( this.fieldCanAdd( id ) ) {
  		    if ( n === undefined ) n = -1;
		      if ( !( id in this.fields ) ) this.$set( this.fields, id, { id, values: [] } );
		      const v = { };
		      if ( this.referenceIs( this.attrs_[ id ] ) ) {
		        v.id = null;
		        v.name = ""
          }
		      else {
		        v.lang = this.langData;
            v.value = "";
          }
		      this.fields[ id ].values.splice( n + 1, 0, v );
		    }
      },

      fieldRem( id, n ) {
		    if ( this.fieldCanRemove( id ) ) {
  		    if ( !n ) n = -1;
		      this.fields[ id ].values.splice( n, 1 );
		    }
      },

      fieldGetValue( id, n ) {
        return this.fieldValueConvert( this.attrs_[ id ].type.toLowerCase(), this.fields[ id ].values[ n ] );
      },

      fieldSetValue( id, n, value ) {
		    value = this.fieldValueConvert( this.attrs_[ id ].type.toLowerCase(), value, true );
		    if ( id == this.$options.aType && this.fields[ id ].values.find( i => i.id == value.id ) ) return;

        if ( this.referenceIs( this.attrs_[ id ] ) ) this.$set( this.fields[ id ].values, n, value );
        else this.$set( this.fields[ id ].values[ n ], "value", value );
      },

      fieldSetStatus( id, n, status ) {
		    if ( !( id in this.fieldsStatuses ) ) this.fieldsStatuses[ id ] = [];
        this.$set( this.fieldsStatuses[ id ], n, status );
      },

      fieldValueConvert( type, v, toDataProvider ) {
		    type = type.toLowerCase();

        if ( v && typeof( v ) == "object" && type !== "reference" ) v = v.value;

        switch ( type ) {
          case "xsd:boolean":
          case "http://www.w3.org/2001/xmlschema#boolean":
            v = v === "true" || v === true || v === 1 || v === "1";
          break;

          case "xsd:date":
          case "http://www.w3.org/2001/xmlschema#date":
            if ( v ) {
              let fr, to, re;

              if ( toDataProvider ) {
                fr = dates.types.RUS4Y;
                to = dates.types.ISO;
                re = /^\s*\d{2}\.\d{2}\.\d{4}\s*$/;
              }
              else {
                fr = dates.types.ISO;
                to = dates.types.RUS4Y;
                re = /^\s*\d{4}-\d{2}-\d{2}(?:\s*|\s+\d{2}:\d{2}:\d{2})$/; //!!! must be /^\s*\d{4}-\d{2}-\d{2}\s*$/ but because sometimes data provider returns time for proprty type xsd:date, it was changed to ignore the time
              }
              if ( re.test( v ) ) {
                try {
                  const s = dates.parse( v, fr );
                  if ( s && s.day !== undefined && s.month !== undefined && s.year !== undefined ) {
                    v = dates.format( s, dates.types.STRUCT, to, false, true );
                  }
                }
                catch ( e ) {}
              }
            }
            else v = "";
          break;

          case "xsd:datetime":
          case "http://www.w3.org/2001/xmlschema#datetime":
            if ( v ) {
              let fr, to, re;
              if ( toDataProvider ) {
                fr = dates.types.RUS4Y;
                to = dates.types.ISO;
                re = /^\s*\d{2}\.\d{2}\.\d{4} \d{2}:\d{2}:\d{2}\s*$/;
              }
              else {
                fr = dates.types.ISO;
                to = dates.types.RUS4Y;
                re = /^\s*\d{4}-\d{2}-\d{2}(?:T|\s+)\d{2}:\d{2}:\d{2}\s*$/;
              }

              if ( re.test( v ) ) {
                try {
                  const s = dates.parse( v, fr );
                  if (
                      s &&
                      s.day !== undefined && s.month !== undefined && s.year !== undefined &&
                      s.hours !== undefined && s.minutes !== undefined && s.seconds !== undefined
                  ) {
                    v = dates.format( s, dates.types.STRUCT, to, true, true );
                  }
                }
                catch ( e ) {}
              }
            }
            else v = "";
          break;
        }

        return v;
      },

      fieldsErrorClear( id, n ) {
		    if ( id ) {
		      if ( n === undefined ) this.fieldsErrors[ id ] = [];
		      else this.$delete( this.fieldsErrors[ id ], n );
        }
		    else this.fieldsErrors = {};
      },
      fieldsError( id, n, msg ) {
		    if ( !this.fieldGetValue( id, n ) ) this.fieldAdd( id, n ); //if there is an error for field without any values - open it with empty value to show the error

		    if ( !( id in this.fieldsErrors ) ) this.$set( this.fieldsErrors, id, [] );
		    let m = this.fieldsErrors[ id ][ n ] ? this.fieldsErrors[ id ][ n ] : "";
		    this.$set( this.fieldsErrors[ id ], n, m + ( m ? "<br />" : "" ) + msg );
      },
      fieldsErrorGet( id, n ) {
		    if ( id in this.fieldsErrors && this.fieldsErrors[ id ][ n ] ) return this.fieldsErrors[ id ][ n ];
		    return null;
      },

      async save() {
		    this.loading = true;

        this.fieldsErrorClear();

		    if ( this.fields ) {
		      for ( const aid in this.fields ) {
		        if ( this.fields.hasOwnProperty( aid ) ) {
		          const attrEdit = this.fields[ aid ];
		          const attr = this.attrs_[ aid ];

              const values = utils.cloneDeep( attrEdit ).values;

              let msg = null;

              for ( let vk = 0; vk < values.length; vk++ ) {
                const v = values[ vk ];
                let vv = v.value;

                switch( attr.type.toLowerCase() ) {
                  case "reference":
                    vv = v;
                    if ( !vv || !vv.id ) msg = "<b>" + this.$t( "RefCantEmpty" ) + ".</b><br /><br />" + this.$t( "RefFillOrRemove" ) + ".";
                  break;

                  case "xsd:date":
                  case "http://www.w3.org/2001/xmlschema#date":
                    vv = ( vv + "" ).trim();
                    if ( vv && !dates.check( vv, dates.types.ISO ) ) msg = "<b>" + this.$t( "InvalidDateFormat" ) + ".</b><br /><br />" + this.$t( "UseDateFormat" );
                  break;

                  case "xsd:datetime":
                  case "http://www.w3.org/2001/xmlschema#datetime":
                    vv = ( vv + "" ).trim();
                    if ( vv && !dates.check( vv, dates.types.ISO, true ) ) msg = "<b>" + this.$t( "InvalidDateFormat" ) + ".</b><br /><br />" + this.$t( "UseDatetimeFormat" );
                  break;

                  case "xsd:double":
                  case "http://www.w3.org/2001/xmlschema#double":
                    if ( vv && !/^[+-]?(?:\d+\.)?\d+$/.test( vv ) ) msg = "<b>" + this.$t( "InvalidDoubleFormat" ) + ".</b><br /><br />" + this.$t( "UseDoubleFormat" );
                  break;

                  case "xsd:integer":
                  case "http://www.w3.org/2001/xmlschema#integer":
                    if ( vv && !/^[+-]?\d+$/.test( vv ) ) msg = "<b>" + this.$t( "InvalidIntegerFormat" ) + ".</b><br /><br />" + this.$t( "UseIntegerFormat" );
                  break;
                }

                if ( msg ) this.fieldsError( aid, vk, msg );
                if ( this.fieldsStatuses[ aid ] && this.fieldsStatuses[ aid ][ vk ] ) this.fieldsError( aid, vk, this.fieldsStatuses[ aid ][ vk ] );
              }

              if ( attr.carMin ) {
                let filled = 0;
                for ( const v of values ) if ( !!v.value || !!v.id ) filled++;
                if ( filled < attr.carMin ) this.fieldsError( aid, 0, "<b>" + this.$t( "MinFieldsFilled" ) + " - " + attr.carMin + "</b><br /><br />" + this.$t( "FillMissingFields" ) + "." );
              }
            }
          }

		      await this.$nextTick();
		      //scroll to the first visible error
		      for ( const e of this.$refs.fieldErrorTip ) {
		        if ( e.$el.tagName ) {
		          const input = e.$el.parentNode.querySelector( "input, textarea" );
		          if ( input ) input.focus();
		          e.$el.parentNode.scrollIntoView( { alignToTop: true, behavior: "smooth" } );
		          break;
            }
          }
		      if ( !this.fieldsErrorsFound ) {
		        let classes = [];
		        const attrs = {};
		        const name = this.item_.name;

		        for ( const aid in this.fields ) {
		          if ( this.fields.hasOwnProperty( aid ) ) {
		            const attr = this.fields[ aid ];
		            if ( aid == this.$options.aType ) classes = attr.values.map( i => i.id );
		            else attrs[ aid ] = attr.values;
              }
            }

            try {
              let ans = await this.$options.api.patch.json(
                "/editing",
                {
                  ...this.apiQueryStd,
                  classes,
                  id: this.id,
                  attrs,
                  updateMode: "substitution",
                },
                undefined,
                false
              );

// !!! MOCK! убрать
//              const ans = { id: this.id };

              if ( !ans || ( ans.errors && ans.errors.length ) || !ans.id ) {
                this.$root.$emit( "notify", { header: this.$t( "ObjectsSaveError" ), message: ans ? ans.errors.join( "<br />" ) : this.$t( "InvalidServerAnswer" ), type: "error" } );
              }
              else {
               //this.$root.$emit( "notify", { header: undefined, message:  this.$t( "Object" ) + " «" + name + "» " + this.$t( "savedSuc" ), type: "info" } );

                if ( ans.violations && ans.violations.length ) {
                  let text = this.$t( "ViolationConstraintsRules" ) + ":";
                  for ( const v of ans.violations ) text += "<br />" + v.Message;

                  this.$root.$emit( "notify", { header: this.$t( "ViolationsDetected" ), message: text, type: "warning" } );
                }

                const affected = ans.affected || {};
                const idNew = ans.id;

                ans = await this.$options.api.post.json(
                  "/editing",
                  {
                    ...this.apiQueryStd,
                    id:  idNew
                  },
                  undefined,
                  false
                );

                if ( !ans || ( ans.errors && ans.errors.length ) || !ans.item ) {
                  this.$root.$emit( "notify", { header: this.$t( "SavedObjectGetError" ), message: ans.errors.length ? ans.errors.join( "<br />" ) : this.$t( "InvalidServerAnswer" ), type: "error" } );
                }
                else {
                  const item = ans.item;

                  let msg = "";
                  if ( !utils.objIsEmpty( affected ) ) {
                    msg += this.$t( "ObjectsChangedByRules" ) + ': ';
                    for ( const oid in affected ) {
                      if ( affected.hasOwnProperty( oid ) ) {
                        msg += "\"<b>" + affected[ oid ] + "</b>\", "
                      }
                    }
                    msg = msg.slice( 0, -2 );
                  }
                  this.$root.$emit( "notify", { header: this.$t( "Object" ) + " «" + ( this.itemName( item ) ) + "» " + this.$t( "savedSuc" ), message:  msg, type: "info" } );
                }

                if ( this.requestOnSave ) {
                  await this.dataRq( true );
                  this.$emit( "input", { operation: "save", id: this.id, item: this.item_, attrs: this.attrs } );
                }
                else this.$emit( "input", { operation: "save", id: this.id, classes: classes.reduce( ( a, i ) => { a[ i ] = i; return a; }, {} ), attrs } );
              }
            }
            catch ( e ) {
                this.$root.$emit( "notify", { header: this.$t( "ObjectsSaveError" ), message: e.message, type: "error" } );
                console.error( e );
            }
          }

          this.loading = false;
        }
      },

      async del() {
		    this.loading = true;

        try {
          const ans = await this.$options.api.delete.json(
            "/editing",
            {
              ...this.apiQueryStd,
              ids: [ this.item_.id ]
            },
            undefined,
            false
          );

          if ( ans && ( !ans.errors || !ans.errors.length ) && ans.ids && ans.ids.length ) {
            this.$root.$emit( "notify", { header: this.$t( "Object" ) + " «" + ( this.item_.name ? this.item_.name : this.item_.id ) + "» ", message:  this.$t( "savedSuc" ), type: "info" } );

            this.$emit( "input", { operation: "delete", id: this.id, item: this.item_, attrs: this.attrs } );
            this.$emit( "close", { operation: "delete" } );
          }
          else {
            this.$root.$emit( "notify", { header: this.$t( "ObjectsDeleteError" ), message: ans ? ans.errors.join( "<br />" ) : this.$t( "InvalidServerAnswer" ), type: "error" } );
          }
        }
        catch ( e ) {
            this.$root.$emit( "notify", { header: this.$t( "ObjectsDeleteError" ), message: e.message, type: "error" } );
            console.error( e );
        }

        this.loading = false;
      },

      attrGetRefs( aid ) {
		    if ( this.attrs_ && ( aid in this.attrs_ ) ) {
		      const attr = this.attrs_[ aid ];
          if ( attr.type === "reference" ) return Object.keys( attr.refs );
        }

        return [];
      },

      itemName( item ) {
		    return item ? ( item.name ? item.name : item.id ) : "";
      },

      violationsSeverityGet( vs ) {
		    let gsi = -1;
		    for ( const id in vs ) {
		      if ( vs.hasOwnProperty( id ) ) {
		        const s = vs[ id ].severity;
		        const si = this.$options.severities.indexOf( s );
		        if ( si >= 0 && ( gsi < 0 || si < gsi ) ) gsi = si;
          }
        }

		    if ( gsi >= 0 ) return this.$options.severities[ gsi ].replace( /^[^#]+#/, "v" );

		    return "";
      },

      consMandWarn( item, aid ) {
		    if ( !item || !aid || !this.consMand ) return false;

		    if (
		      !this.consMand.has( aid ) ||
          (
            item.attrs &&
            ( aid in item.attrs ) &&
            item.attrs[ aid ].values &&
            item.attrs[ aid ].values.length &&
            item.attrs[ aid ].values.findIndex( i => ( i.id || ( i.value === 0 || !!i.value ) ) ) >= 0
          )
        ) return false;

		    return true;
      }
    },

    computed: {
      apiQueryStd() {
        return {
          ...this.queryStd,

          endpoint: this.endpoint,
          clientId: this.clientId,

          langInterf: this.langInterf
        };
      },

      itemHash() {
		    return [ this.endpoint, this.classId, this.id, this.item, this.attrs ];
      },
      itemAndAttrsAvailable() {
        return [ this.item_, this.attrs_ ];
      },

      fieldsErrorsFound() {
        for ( const id in this.fieldsErrors ) {
          if ( this.fieldsErrors.hasOwnProperty( id ) ) {
            const errors = this.fieldsErrors[ id ];
            for ( const err of errors ) if ( err ) return true;
          }
        }

        return false;
      },

      canSave() {
        return this.canUpdate || ( this.canCreate && !this.id );
      }
    },

    watch: {
		  itemHash: {
		    handler() {
    		  this.dataRq();
        },
        immediate: true
      },
      attrs_: {
		    handler() {
          if ( this.attrs_ ) {
            if ( !( this.$options.type in this.attrs_ ) ) {
              this.attrs_[ this.$options.aType ] = {
                id:       this.$options.aType,
                name:     "Относится к классу",
                archive:  false,
                type:     "reference",
                refs:     { "http://www.w3.org/2002/07/owl#Class": "Класс" },
                carMin:   1,
                carMax:   null
              }
            }

            const a = this.attrs_[ this.$options.aType ];
            if ( !a.carMin ) a.carMin = 1;
          }
        },
        immediate: true
      },
      itemAndAttrsAvailable: {
		    handler() {
		      let fields = null;
		      this.fieldsErrorClear();

		      if ( this.item_ && this.attrs_ ) {
		        fields = {};

		        //store all attributes and fill theirs values from entity's not inferred attributes
		        for ( const id in this.attrs_ ) {
		          if ( this.attrs_.hasOwnProperty( id ) ) {
		            const attr = this.attrs_[ id ];
		            const attrIsRef = this.referenceIs( attr );
		            const attrType = attr.type.toLowerCase();

		            if ( !( id in fields ) ) fields[ id ] = { values: [] };

		            if ( id in this.item_.attrs ) {
		              for ( const a of this.item_.attrs[ id ].values ) {
		                if ( !a.inferred ) {
		                  const ac = utils.cloneDeep( a );
		                  delete ( ac.inferred );
		                  fields[ id ].values.push( ac );
                    }
                  }
                }

		            //respect minimal cardinality
		            if ( attr.carMin ) {
		              let l = attr.carMin - fields[ id ].values.length;
		              while ( l > 1 ) {
		                fields[ id ].values.push( attrIsRef ? { id: null, name: "" } : { lang: null, value: "" } );
		                l--;
                  }
                }
              }
            }

		        //store classes as an attribute
		        for ( const id in this.item_.classes ) {
		          if ( this.item_.classes.hasOwnProperty( id ) ) {
		            if ( !( this.$options.aType in fields ) ) {
                  fields[ this.$options.aType ] = { values: [] };
                }

		            fields[ this.$options.aType ].values.push(
                  {
                    id,
                    name: this.item_.classes[ id ]
                  }
                );
              }
            }
          }

		      this.fields = fields;
        },
        immediate: true
      }
    },
  };
</script>

<style scoped>
.empty {
}

table > tr > td,
table > tbody > tr > td,
table > tr > th,
table > tbody > tr > th {
  vertical-align: top;
  padding: 0.2em;
}

.attrs {
  margin-top: 1em;
  border: solid 1px #808080;
  border-radius: 0.1em;
  width: 100%;
}
.attrs:first-child {
  margin-top: 0;
}

.main > tbody > tr > td:last-child,
.main > tr > td:last-child{
  width: 1em;
}

.attrs > tbody > tr > th,
.attrs > tbody > tr > td,
.attrs > tr > th,
.attrs > tr > td {
  padding: 0 1em;
  border: solid #808080;
  border-width: 0 1px 1px 0;
  text-align: left;
  vertical-align: top;
}
.attrs > tbody > tr > th:last-child,
.attrs > tbody > tr > td:last-child,
.attrs > tr > th:last-child,
.attrs > tr > td:last-child  {
  border-right-width: 0;
}
.attrs > tbody > tr:last-child > th,
.attrs > tbody > tr:last-child > td,
.attrs > tr:last-child > th,
.attrs > tr:last-child > td {
  border-bottom-width: 0;
}

.attrs > tbody > tr > th,
.attrs > tr > th {
  background-color: #F2F6FB;
  color: #4D4D4D;
  font-weight: bold;
}

.attrs > tbody > tr > td,
.attrs > tr > td {
  color: #212121;
}

.violations {
  display: inline-block;
  position: relative;
}

.violations svg {
  cursor: pointer;
  fill: #FB6E19;
  margin-top: -0.2em;
}

.violations.vViolation svg {
  fill: #FF0000;
}
.violations.vWarning svg {
  fill: #FFAA00;
}
.violations.vInfo svg {
  fill: #00C616;
}


.violations > .tip {
  position: absolute;
  top: 1em;
  left: -0.4em;
  min-width: 10em;
}
.violations > .tip::v-deep .violation {
  margin-top: 1em;
}
.violations > .tip::v-deep .violation:first-child {
  margin-top: 0;
}

.inferred {
  font-size: 0.8em;
  color: #808080;
}

span.lang {
  font-size: 0.8em;
  color: #808080;
  white-space: nowrap;
  padding-left: 0.5em;
}
.values td,
.values td > div {
  border: dotted #000000;
  border-width: 0 0 1px 0;
}
.values:last-child td,
.values td > div:last-child {
  border-bottom-width: 0;
}

.links {
  color: #000000;
  font-size: 0.8em;
  margin-left: 0.5em;
}
.links:before {
  content: "( классы: ";
}
.links:after {
  content: " )";
}

.historyAttrRq {
  display: block;
  cursor: pointer;
  fill: #007BC1;
}
.historyAttrRq:hover {
  fill: #0C97E7;
}

.field {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.field button {
  border: none;
  padding: 0;
  background: none;
  cursor: pointer;
  line-height: 1em;
  margin: 0.5em;
  font-size: 1.3em;
}

.field .lang {
  margin-right: 1em;
}

.field .link {
  margin: 0 1em;
}

.save {
  margin-top: 1em;
}

/* remove all internal fields tooltip, cause they already have tooltips there */
.field > .DVfield::v-deep .tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
}

.wrapper .DVfield,
.wrapper select,
.wrapper *[data-focus] {
  box-shadow: inset 0 0 1px 1px rgba( 0, 0, 0, 0.25 ) !important;
  border-radius: 2px !important;
  background-color: transparent;
}
.wrapper .DVfield::v-deep input,
.wrapper .DVfield textarea,
.wrapper select,
.wrapper .DVfield.radio {
  box-shadow: none !important;
  background-color: transparent;
  font: inherit;
}

button:hover,
button:hover * {
  transition: all .25s ease;
}

.link,
button {
  fill: #000000;
  stroke: #000000;
  transition: all .25s ease;
}
.link:hover,
.link:hover *,
button:hover,
button:hover * {
  fill: #4D4D4D;
  stroke: #4D4D4D;
}

.consMand {
  display: inline-block;
  position: relative;
}
.consMand svg {
  cursor: pointer;
  fill: #67ADFF;
  margin-top: -0.2em;
}
.consMand > .tip {
  position: absolute;
  top: 1em;
  left: -0.4em;
  min-width: 10em;
}

</style>